// extracted by mini-css-extract-plugin
export default {"semesterSwitcher":"kNQtumWf","semesterName":"WC_quwzc"};